"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Folder = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Folder = function Folder() {
  return react_1.default.createElement("path", {
    opacity: "0.4",
    d: "M21 10.0005V17.0005C21 19.0005 20 20.0005 18 20.0005H6C4 20.0005 3 19.0005 3 17.0005V7.00049C3 5.00049 4 4.00049 6 4.00049H10L13 7.00049H18C20 7.00049 21 8.00049 21 10.0005Z",
    fill: "black"
  });
};

exports.Folder = Folder;